import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import classNames from 'classnames';
import { RouterStore } from 'mobx-react-router';
import get from 'lodash/get';
import Icon from '@xo-union/tk-component-icons';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import AnalyticsStore from '~/glm/models/analytics-store';
import styles from './add-guest-button.scss';
import { Body1 } from '@xo-union/tk-ui-typography';
import { ButtonDropdown, AddGuestDropdownItem } from '../../button-dropdown';
import { withRouter } from 'react-router-dom';

@inject('gdsUiState', 'analyticsStore', 'routerStore')
@observer
class AddGuestButton extends Component {
  onAddClick = () => {
    const { gdsUiState, analyticsStore } = this.props;
    gdsUiState.setShowHouseholdForm(true);
    analyticsStore.track('Dashboard Interaction', {
      action: 'add guest initiated',
    });
  };

  onImportClick = () => {
    const { gdsUiState, analyticsStore, location, history } = this.props;
    const onEventId = get(location, 'query.event');
    let route = '/our-guest-list/import-spreadsheet';
    if (onEventId && onEventId !== 'all') route = `${route}?event=${onEventId}`;

    gdsUiState.setImportSpreadsheetView(true);
    history.push(route);
    analyticsStore.track('Dashboard Interaction', {
      action: 'Import Spreadsheet Initiated',
      source: 'guest list',
      view: 'import spreadsheet',
    });
  };

  onCollectClick = () => {
    const { gdsUiState, analyticsStore, history } = this.props;
    gdsUiState.setAddressCollectionView(true);
    history.push('/our-guest-list/address-collection');
    analyticsStore.track('Dashboard Interaction', {
      action: 'Address Collection Initiated',
      source: 'guest list',
      view: 'address collection form',
    });
  };

  toggleOpen = () => {
    this.setState({ isOpen: false });
  };

  render() {
    return (
      <>
        <ButtonDropdown className={classNames('cta', styles.addGuestButton)} color="primary" size="lg" text="Add Guest">
          <AddGuestDropdownItem onClick={this.onAddClick} data-testid="add-guest-individual">
            <div className={styles.dropdownItem}>
              <Icon name="user" size="sm" className={styles.linkIcon} />
              <Body1>Add guests one by one</Body1>
              <div className={styles.subtext}>Type guests&apos; info directly onto your list</div>
            </div>
          </AddGuestDropdownItem>
          <AddGuestDropdownItem onClick={this.onImportClick} data-testid="add-guest-import">
            <div className={styles.dropdownItem}>
              <Icon name="users" size="sm" className={styles.linkIcon} />
              <Body1>Use a spreadsheet</Body1>
              <div className={styles.subtext}>Add multiple guests quickly using a template</div>
            </div>
          </AddGuestDropdownItem>
          <AddGuestDropdownItem onClick={this.onCollectClick} data-testid="add-guest-collect">
            <div className={styles.dropdownItem}>
              <Icon name="pointer" size="sm" className={styles.linkIcon} />
              <Body1>Collect addresses</Body1>
              <div className={styles.subtext}>Send guests your address collection form link</div>
            </div>
          </AddGuestDropdownItem>
        </ButtonDropdown>
      </>
    );
  }
}

AddGuestButton.propTypes = {
  gdsUiState: PropTypes.instanceOf(GdsUiState),
  analyticsStore: PropTypes.instanceOf(AnalyticsStore),
  routerStore: PropTypes.instanceOf(RouterStore),
  history: PropTypes.object.isRequired,
};

export default withRouter(observer(AddGuestButton));
